import { isNullOrUndefined } from '@app/util/util';

export function getSimpleDateByRecent(date: string): string {
  let stringByDate = '';
  const utcRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})(?:\.\d+)?Z?/;
  const utcParts = date.match(utcRegex);
  if (isNullOrUndefined(utcParts)) {
    const isoRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})([zZ]|([+-](\d{2})\:(\d{2})))/;
    const isoParts = date.match(isoRegex);
    if (isNullOrUndefined(isoParts)) {
      return date;
    } else {
      stringByDate = getDateFormat(date, isoParts[2], isoParts[1], isoParts[3], isoParts[4], isoParts[5], isoParts[6]);
    }
  } else {
    stringByDate = getDateFormat(date, utcParts[2], utcParts[1], utcParts[3], utcParts[4], utcParts[5], utcParts[6]);
  }
  return stringByDate;
}

function getDateFormat(
  date: string,
  sMonths: string, sYear: string, sDays: string,
  sHours: string, sMinutes: string, sSeconds: string
): string {
  let months, days, hours, minutes, seconds = 0;
  const year = Number(sYear);
  if (!isNullOrUndefined(sMonths) && !isNullOrUndefined(sDays)) {
    months = Number(sMonths);
    days = Number(sDays);
  }
  if (!isNullOrUndefined(sHours) && !isNullOrUndefined(sMinutes)) {
    hours = Number(sHours);
    minutes = Number(sMinutes);
    if (!isNullOrUndefined(sSeconds)) {
      seconds = Number(sSeconds);
    }
  }
  return getStringDate(date, months, year, days, hours, minutes, seconds);
}

function getStringDate(
  date: string, months: number, year: number, days: number,
  hours: number, minutes: number, seconds: number
): string {
  if (!year || !months || !days) {
    return date;
  } else {
    const sH = hours < 10 ? `0${hours}` : hours;
    const sM = minutes < 10 ? `0${minutes}` : minutes;
    const sS = seconds < 10 ? `0${seconds}` : seconds;
    const sMTH = months < 10 ? `0${months}` : months;
    const sDay = days < 10 ? `0${days}` : days;
    return `${year}-${sMTH}-${sDay}T${sH}:${sM}:${sS}`;
  }
}
